import Vue from 'vue';

Vue.component('donation-form-component', {
    props: {
        donationTerms: {
            type: String,
            required: true
        },
        donationRecurringTerms: {
            type: String,
            required: true
        },
        initRecurring: {
            type: Boolean,
            default: false
        },
        initAmount: {
            type: Number,
            default: 10
        },
        formHashes: {
            type: String,
            required: true
        },
        storedData: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            recurring: false,
            donationAmount: 10,
            manualSelect: false,
            donatorFirstName: '',
            donatorLastName: '',
            donatorEmail: '',
        };
    },

    mounted() {
        // Set initial values
        this.recurring = this.initRecurring;
        this.donationAmount = this.initAmount;

        // Set values if payment failed / something else
        const data = JSON.parse(this.storedData);
        if (data.firstName && data.lastName && data.email && data.amount) {
            this.donatorFirstName = data.firstName;
            this.donatorLastName = data.lastName;
            this.donatorEmail = data.email;
            this.donationAmount = Number(data.amount.replace(/\.00$/, ''));
        }
    },

    computed: {
        getAction() {
            if (this.recurring) {
                return 'mollie-payments/subscription/subscribe';
            }

            return 'mollie-payments/payment/donate';
        },

        getFormHash() {
            const hashes = JSON.parse(this.formHashes);
            if (this.recurring) {
                return hashes.recurring;
            }

            return hashes.singleDonation;
        },

        getDonationAmount() {
            if (!this.recurring) {
                return this.donationAmount;
            }

            const el = this.$el.querySelector(`[data-recurring-amount="${this.donationAmount}"]`)
            const { recurringHash } = el.dataset;
            return recurringHash ? recurringHash : this.donationAmount;
        },

        getDonationTerms() {
            const terms = this.recurring ? this.donationRecurringTerms : this.donationTerms;
            return `${terms} € ${this.donationAmount || 0}.`;
        }
    },

    methods: {
        toggleManualAmount() {
            this.manualSelect = !this.manualSelect;
        }
    }
});
